import React, { Component } from 'react'
import { Button, Tabs, Select, Icon } from 'antd'
import { LoadingFactory } from 'components/LoadingFactory'
import { PushNotification } from 'utils/PushNotification'
import { BaseRequest, ContactRequest } from 'models/request/Index'
import { Information } from './information/Index'
import { PermissionService } from 'services/PermissionService'
import { getContact } from 'services/CeberusApiService'
import { Permissions } from 'permissions'
import { Context } from './context/Index'
import { Tenant } from 'models/Blip/Tenant'
import { TenantService } from 'connection/TenantService'

const { TabPane } = Tabs;
const CONTEXT = '2';
const INFORMATION = '1';

export class Contacts extends Component<BaseRequest> {
  constructor(props: BaseRequest) {
    super(props);

    this.state = {
      contacts: [],
      isLoading: false,
      activeContact: undefined,
      userHasStatePermission: PermissionService.hasPermission(Permissions.Application_Contacts_State),
      contextRefreshKeys: {},
      isRefreshing: false,
      activeInnerTabs: {}
    };

    this.tenantSelected = TenantService.getSelectedTenant();
    this.setActiveContact = this.setActiveContact.bind(this);
  }

  tenantSelected: Tenant;

  state = {
    contacts: [],
    isLoading: false,
    activeContact: undefined,
    userHasStatePermission: false,
    contextRefreshKeys: {},
    isRefreshing: false,
    activeInnerTabs: {}
  }

  setActiveContact(activeKey: string){
    if(activeKey == undefined){
      if (this.state.contacts.length && this.state.activeContact === undefined) {
        this.setState({ activeContact: this.state.contacts[0].name });
      }
    }
    else{
      this.setState({ activeContact: activeKey });
    }
  }

  getContactByIdentity = async (contactIdentity: string) : Promise<void> => {
    const contact = await getContact(new ContactRequest(contactIdentity, this.tenantSelected.name, this.props.BotIdentifier));

    if (contact) {

      const contactsInState = this.state.contacts.find(c => c.identity === contact.identity);

      if (!contactsInState)
        {
        const { contacts } = this.state;
        const newContact = { ...contact, tabKey: this.getKeyIdentifier(contact) };
        this.setState({ contacts : [...contacts, { ...newContact }] });
      }
      this.setActiveContact(undefined);
    }

  }
  refreshContact = async (contactIdentity: string): Promise<void> => {
    try {
      const contact = await getContact(new ContactRequest(contactIdentity, this.tenantSelected.name, this.props.BotIdentifier));
      if (!contact) {
        PushNotification.error("Contact not found.");
        return;
      }
      const updatedContactWithKey = { ...contact, tabKey: this.getKeyIdentifier(contact) }
      const newContacts = this.state.contacts.map(c => c.identity === contactIdentity ? updatedContactWithKey : c)
      this.setState({ contacts: newContacts, activeContact: updatedContactWithKey.tabKey })
    } catch (error) {
      console.error("Error to reload contact:", error);
      PushNotification.error("Error to reload contact.");
    } 
  }
  forceContextRefresh = (identity: string) => {
    this.setState(prev => {
      const previousKeys = (prev as any).contextRefreshKeys || {}
      const previousValue = previousKeys[identity] || 0

      return {
        contextRefreshKeys: {
          ...previousKeys,
          [identity]: previousValue + 1
        }
      }      
    })
  }
  setActiveInnerTab = (identity: string, key: string) => {
    this.setState(prev => ({
      activeInnerTabs: { ...((prev as any).activeInnerTabs || {}), [identity]: key }
    }))
  }

  onSearchContacts = async (identifiers: any) : Promise<any> => {

    if (!identifiers || !identifiers.length) return;

    try {
      this.setState({ isLoading: true });
      const contactsToBeAdded = identifiers.filter((identifier: string) => !this.state.contacts.find(c => c.identity === identifier));
      return await Promise.all(contactsToBeAdded.map(this.getContactByIdentity));
    } catch (error) {
      PushNotification.error('Contact not found.');
    } finally {
      this.setState({ isLoading: false });
    }

  }

  removeContactByIdentifier = (identifier: string) : void => {
    const { contacts } = this.state;
    const indexToRemove = contacts.findIndex((contact) => contact.tabKey == identifier);

    if (indexToRemove !== -1) {
      const newContacts = [...contacts];
      newContacts.splice(indexToRemove, 1);
      this.setState({ contacts: newContacts });
    }
  }

  getKeyIdentifier = (contact: any) : string => {
    return contact.name ? contact.name : contact.identity.split('@')[0];
  }

  render() {

    const {  isLoading,  contacts,  activeContact,  userHasStatePermission } = this.state;

    return (
      <>
        <div style={{ width: 400, margin: 'auto' }}>
          <h2>
            <Icon type="user" className="mr3" />
            Search contacts of current chatbot
          </h2>
          <Select
            tokenSeparators={[',', ';', ' ']}
            mode="tags"
            allowClear
            onChange={this.onSearchContacts}
            onDeselect={this.removeContactByIdentifier}
            style={{ width: '100%' }}
          />
        </div>
        <div className="mt5 w-100">
          {isLoading ? (
            <LoadingFactory />
          ) : (
            <Tabs
              hideAdd
              type="editable-card"
              onChange={this.setActiveContact}
              activeKey={activeContact}
              onEdit={this.removeContactByIdentifier}
            >
              {contacts.length > 0
                ? contacts.map(contact => (
                  <TabPane
                    tab={contact.tabKey}
                    key={contact.tabKey}
                    closable
                  >
                    <Button
                      icon="reload"
                      type="dashed"
                      size="small"
                      title='Updates both tabs — Information and Context — for this contact only'
                      onClick={() => {
                        this.refreshContact(contact.identity)
                        this.forceContextRefresh(contact.identity)
                      }}
                    >Refresh</Button>
                    <Tabs activeKey={
                      this.state.activeInnerTabs &&
                      this.state.activeInnerTabs[contact.identity] ||
                      INFORMATION
                    }
                      onChange={(key) => this.setActiveInnerTab(contact.identity, key)}
                    >
                      <TabPane key={INFORMATION} tab="Information">
                        <Information contact={contact} refreshKey={this.state.contextRefreshKeys && this.state.contextRefreshKeys[contact.identity]} />
                      </TabPane>
                      <TabPane key={CONTEXT} tab="Context" disabled={!userHasStatePermission}>
                        <Context ownerIdentity={this.props.BotIdentifier} contact={contact} refreshKey={this.state.contextRefreshKeys && this.state.contextRefreshKeys[contact.identity]} />
                      </TabPane>
                    </Tabs>
                  </TabPane>
                ))
                : null}
            </Tabs>
          )}
        </div>
      </>
    )
  }
}